import { RoutePoint } from "../../../models/routes/routePoint";
import ListItemCard from "../../../components/containers/listItemCard";
import clsx from "clsx";
import { Col, Row } from "reactstrap";
import { RoutePointStatus } from "../../../models/enums/routePointStatus";

const getStatusText = (status: RoutePointStatus): string => {
    switch (status) {
        case RoutePointStatus.Open:
            return "Закройте предыдущие адреса маршрута";
        case RoutePointStatus.Cancelled:
            return "Точка маршрута отменена";
        case RoutePointStatus.Rejected:
            return "Точка маршрута отклонена";
        default:
            return "Неизвестный статус";
    }
};

const InactivePoint: React.FC<{ routePoint: RoutePoint }> = ({ routePoint }) => (
    <ListItemCard className={clsx("border-start border-5", "border-secondary")}>
        <Row className="gx-2">
            <Col xs={3}>Адрес:</Col>
            <Col className="fw-bold">{routePoint.city}</Col>
        </Row>
        <div className="mt-2 text-center">{getStatusText(routePoint.status)}</div>
    </ListItemCard>
);

export default InactivePoint;
